// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "meta_campaign_daily_insights".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "meta_campaign_daily_insights" table (1:1 with a DB row, on the wire). */
export const metaCampaignDailyInsightsAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    metaCampaignId: z.string(),
    metaAdId: z.string().nullable(),
    date: z.string().datetime(),
    spend: z.number(),
    currency: z.string(),
    cpc: z.number().nullable(),
    cpm: z.number().nullable(),
    spendUsd: z.number(),
    cpcUsd: z.number().nullable(),
    cpmUsd: z.number().nullable(),
    exchangeRate: z.string().nullable(),
    impressions: z.number(),
    reach: z.number(),
    clicks: z.number(),
    leads: z.number(),
    conversions: z.number(),
    ctr: z.string().nullable(),
    frequency: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=metaCampaignDailyInsights.js.map